import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './RoomPopoverContent.module.css'

const RoomPopoverContent: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={`display-flex gap-l padding-m ${styles.container}`}>
      <span className={'font-body-medium-regular'}>{t('wizard.screen.basicInfo.room.popover.introduction')}</span>
      <span className={'font-body-medium-regular'}>
        <strong>{t('wizard.screen.basicInfo.room.popover.fullRoomLabel')}</strong>{' '}
        {t('wizard.screen.basicInfo.room.popover.fullRoomDescription')}
      </span>
      <span className={'font-body-medium-regular'}>
        <strong>{t('wizard.screen.basicInfo.room.popover.halfRoomLabel')}</strong>{' '}
        {t('wizard.screen.basicInfo.room.popover.halfRoomDescription')}
      </span>
      <span className={'font-body-medium-regular'}>
        <strong>{t('wizard.screen.basicInfo.room.popover.notCountedLabel')}</strong>{' '}
        {t('wizard.screen.basicInfo.room.popover.notCountedDescription')}
      </span>
    </div>
  )
}

export default RoomPopoverContent
